// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use environment variables with fallback to production values for backwards compatibility
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://eyviufsvesiauxhcafax.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV5dml1ZnN2ZXNpYXV4aGNhZmF4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ2Njk1NTEsImV4cCI6MjA3MDI0NTU1MX0.NXnYZCnfhP969AgUEXj5RzeOv1XxPTUKpx5KRzqv3Ps";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});